export function IsInvariantStringMatch(a: string, b: string): boolean {
  return a?.toLowerCase() === b?.toLowerCase();
}
